import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { mapProps } from 'recompose';

const PRODUCTION_BASE_URL = 'https://www.selfstorage.com';

export const enhance = mapProps(({ facility, baseUrl }) => {
	const rootUrl = baseUrl || PRODUCTION_BASE_URL;
	return {
		webPageSchema: {
			'@context': 'https://schema.org',
			'@type': 'WebPage',
			name: facility?.name
				? `${facility.name} | SelfStorage.com`
				: 'SelfStorage.com',
			url: `${rootUrl}${facility?.url || ''}`,
			description: facility?.name
				? `Get the best rate on self storage at ${facility.name}. Compare prices, read verified reviews, and easily reserve online with SelfStorage.com.`
				: 'Get the best rate on self storage. Compare prices, read verified reviews, and easily reserve online with SelfStorage.com.',
			isPartOf: {
				'@type': 'WebSite',
				'@id': 'https://www.selfstorage.com/',
			},
		},
	};
});

export function WebPageSchema({ webPageSchema }) {
	return (
		<Helmet>
			<script type="application/ld+json">
				{JSON.stringify(webPageSchema).replace(/<\//g, '<\\/')}
			</script>
		</Helmet>
	);
}

WebPageSchema.propTypes = {
	webPageSchema: PropTypes.object.isRequired,
};

export default enhance(WebPageSchema);
